<script setup lang="ts">
import { onBeforeMount, reactive, ref, onMounted } from "vue";
import { GoPost } from "../method/Post";
import router from "../router";
import ls from "../method/localStorage";
import { Encrypt } from "../method/Encrypt";
import global from '../global'
import { GetLanguagePack, language } from '../model/language'

const proxy = global();
const lang = ref("简体中文");
const langPack = ref();

onBeforeMount(() => {
    lang.value = ls.get("lang");
    if (lang.value == "" || lang.value == undefined) {
        lang.value = "简体中文"
    }
    langPack.value = proxy.LangPack;
})

onMounted(() => {
    // 监听屏幕旋转事件，让页面能够根据屏幕方向自动调整
    window.addEventListener('orientationchange', () => {
        // 屏幕旋转时不需要特殊处理，因为在main.ts中已经设置了自动更新尺寸
    });
})

let loginUser = reactive({
    UserName: "",
    Password: "",
});

if (ls.get("WebloginId") != null) {
    loginUser.UserName = ls.get("WebloginId");
}



async function Login() {
    if (loginUser.UserName == null || loginUser.Password == null) {
        alert("输入不能为空");
        return;
    }
    let data = {
        username: loginUser.UserName,
        password: Encrypt(loginUser.Password),
        isEncrypt: true
    }

    GoPost("/WebUser/Login", data, (res: any) => {
        ls.set("WebToken", res.token, 60 * 60 * 1000 * 24 * 7);
        ls.set("WebUserId", res.userId, 60 * 60 * 1000 * 24 * 7);
        ls.set("WebOrgId", res.orgId, 60 * 60 * 1000 * 24 * 7);
        ls.set("ModuleId", res.moduleId, 60 * 60 * 1000 * 24 * 7);
        ls.set("CustId", res.custId, 60 * 60 * 1000 * 24 * 7);
        ls.set("WebloginId", loginUser.UserName, 60 * 60 * 1000 * 24 * 7);
        ls.set("Server", res.Server, 60 * 60 * 1000 * 24 * 7)
        ls.set("lang", lang.value, 60 * 60 * 1000 * 24 * 7)
        router.push("/Index");
    }, langPack.value);
}

const watchEnter = (key: any) => {
    if (key.code == "Enter") {
        Login();
    }
}

const handleChangeLanguage = (s: string) => {
    proxy.LangPack = GetLanguagePack(s);
    langPack.value = proxy.LangPack;
    lang.value = s;
    ls.set("lang", lang.value, 60 * 60 * 1000 * 24 * 7);
}

</script>

<template>
    <!-- 根据设备类型自动切换布局 -->
    <div v-if="proxy.clientWidth.value && proxy.clientHeight.value && !proxy.isMobileDevice.value" class="loginbody">
        <div class="loginbody-row">
            <el-image src="/src/assets/logo2.png" fit="contain"
                style="width: 12rem;z-index: 1;position:absolute;top:2.5rem;left: 2.5rem;"></el-image>
            <el-image src="/src/assets/fontground.png" fit="contain"
                style="height:34rem;border: 2px dotted silver;"></el-image>
            <div class="main">
                <el-select v-model="lang" class="select" placeholder="Select" size="small"
                    @change="handleChangeLanguage">
                    <el-option v-for="item in language" :key="item" :label="item" :value="item" />
                </el-select>
                <div style="position: absolute;top: 7rem;height: calc(100% - 12rem);width: 100%;">
                    <h2>{{ langPack.UserLogin }}</h2>
                    <el-form :model="loginUser" label-position="right" label-width="auto" size="large" class="form">
                        <el-form-item :label="langPack.UserName">
                            <el-input v-model="loginUser.UserName"></el-input>
                        </el-form-item>
                        <el-form-item :label="langPack.Password">
                            <el-input v-model="loginUser.Password" type="password" show-password
                                @keydown="watchEnter"></el-input>
                        </el-form-item>
                        <el-button class="loginbutton" type="primary" @click="Login" size="default">{{ langPack.Login
                            }}</el-button>
                    </el-form>
                </div>
                <div class="loginfooter">
                    <small class="text-muted">Copyright 奕鸣科技 </small>
                    <small class="text-muted">浙ICP备2024096675号-1 </small>
                </div>
            </div>
        </div>
    </div>

    <!-- 移动设备布局（横屏和竖屏显示相同的界面） -->
    <el-container
        v-else-if="proxy.isMobileDevice.value && proxy.clientHeight.value && proxy.clientWidth.value && proxy.clientWidth.value <= proxy.clientHeight.value"
        class=" loginbody-vertical">
        <el-select v-model="lang" class="select-vertical" placeholder="Select" size="small"
            @change="handleChangeLanguage">
            <el-option v-for="item in language" :key="item" :label="item" :value="item" />
        </el-select>
        <el-header class="Loginheader">
            <div class="image-vertical">
                <el-image :src="('/src/assets/ymkj2.png')" fit="contain" class="image" />
            </div>
        </el-header>
        <el-main>
            <el-card shadow="always" class="Card-vertical">
                <label class="cardTitle-vertical">{{ langPack.UserLogin }}</label>
                <el-form :model="loginUser" label-position="right" label-width="auto" size="default" class="form-vertical">
                    <el-form-item :label="langPack.UserName">
                        <el-input v-model="loginUser.UserName"></el-input>
                    </el-form-item>
                    <el-form-item :label="langPack.Password">
                        <el-input v-model="loginUser.Password" type="password" show-password
                            @keydown="watchEnter"></el-input>
                    </el-form-item>
                    <el-button type="success" plain @click="Login" size="default">{{ langPack.Login }}</el-button>
                </el-form>
            </el-card>
        </el-main>
    </el-container>
</template>

<style scoped>
.loginbody {
    width: 100vw;
    height: 100vh;
    background-image: url(/src/assets/background.png);
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.select {
    position: absolute;
    right: 1rem;
    top: 1rem;
    width: 10rem;
}



.loginbody-row {
    width: fit-content;
    height: 34rem;
    border-radius: 15px;
    display: flex;
    flex-direction: row;
    position: relative;
}

.main {
    width: 32rem;
    height: 100%;
    background-color: white;
    border-radius: 0 5px 5px 0;
    position: relative;
}

.loginfooter {
    position: absolute;
    bottom: 1rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.loginbutton {
    margin-top: 0rem;
    width: 28rem;
    height: 3rem;
    border-radius: 2.35rem;
    opacity: 1;
    box-shadow: 0px 4px 6px 0px #2C81D9, inset 0px 4px 11px 0px #95C9FF;
    font-size: 1.2rem
}


.loginbody-vertical {
    width: 100vw;
    height: 100vh;
    /* 优先使用--vh变量适配移动设备浏览器工具栏，确保在任何情况下都有足够高度 */
    height: calc(var(--vh, 1vh) * 100);
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
}

/* 为移动设备添加特定的竖屏优化 */
@media screen and (max-width: 768px) {
    .loginbody-vertical {
        overflow-x: hidden;
    }

    .select-vertical {
        position: absolute;
        top: 1rem;
        right: 2rem;
        width: 100vw;
        max-width: 20rem;
    }

    .Loginheader {
        margin-top: 5rem;
        width: 100%;
        height: fit-content;
        padding: 1rem 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }

    .image-vertical {
        max-width: 50vw;
        height: fit-content;
    }

    .Card-vertical {
        margin: 16px;
        width: calc(100% - 16px);
        max-width: 400px;
        margin-left: auto;
        margin-right: auto;
        font-size: 12px;
        background-color: #ecf0f3;
        height: 220px;
    }

    .cardTitle-vertical {
        font-size: 24px;
        text-align: center;
        margin-bottom: 12px;
    }

    .form-vertical {
        padding: 8px;
    }
}

.cardTitle {
    font-size: 6em;
    margin: 0rem;
}

.form {
    margin: 0rem;
    height: fit-content;
    padding: 5%;
    font-size: 1rem;
}
</style>